export default "__VITE_ASSET__mLNDbWxP__"